import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { TaskHistoryAudience } from 'constants/tasks';

// Internal-only lender notes must read distinctly from partner/borrower-facing entries at a glance.
export const AUDIENCE_LABEL_VARIANT = {
  [TaskHistoryAudience.TO_PARTNER]: LabelVariant.BLUE,
  [TaskHistoryAudience.TO_BORROWER]: LabelVariant.PURPLE,
  [TaskHistoryAudience.INTERNAL_ONLY]: LabelVariant.GRAY,
};

export const THREAD_EMPTY_MESSAGE = 'No activity on this task yet.';
export const THREAD_LOAD_ERROR_MESSAGE = "Couldn't load activity. Reopen the task to retry.";
export const COMPOSER_PLACEHOLDER = 'Write a message…';
export const COMPOSER_SEND_LABEL = 'Send';
export const COMPOSER_AUDIENCE_LABEL = 'Audience';
export const COMPOSER_MESSAGE_MAX_LENGTH = 1000;
export const COMPOSER_MESSAGE_ROWS = 3;
export const RETURN_ENTRY_TITLE = 'Returned for correction';
export const MESSAGE_POSTED_SUCCESS = 'Message posted';

export const TaskThreadTagType = {
  AUDIENCE: 'audience',
  STATUS: 'status',
};
